"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBitSet = exports.parseTagFlags = exports.TagField = exports.TagItemHeader = exports.TagFooter = exports.Header = exports.DescriptorParser = exports.DataType = void 0;
const Token = require("token-types");
const FourCC_1 = require("../common/FourCC");
var DataType;
(function (DataType) {
    DataType[DataType["text_utf8"] = 0] = "text_utf8";
    DataType[DataType["binary"] = 1] = "binary";
    DataType[DataType["external_info"] = 2] = "external_info";
    DataType[DataType["reserved"] = 3] = "reserved";
})(DataType = exports.DataType || (exports.DataType = {}));
exports.DescriptorParser = {
    len: 52,
    get: (buf, off) => {
        return {
            ID: FourCC_1.FourCcToken.get(buf, off),
            version: Token.UINT32_LE.get(buf, off + 4) / 1000,
            descriptorBytes: Token.UINT32_LE.get(buf, off + 8),
            headerBytes: Token.UINT32_LE.get(buf, off + 12),
            seekTableBytes: Token.UINT32_LE.get(buf, off + 16),
            headerDataBytes: Token.UINT32_LE.get(buf, off + 20),
            apeFrameDataBytes: Token.UINT32_LE.get(buf, off + 24),
            apeFrameDataBytesHigh: Token.UINT32_LE.get(buf, off + 28),
            terminatingDataBytes: Token.UINT32_LE.get(buf, off + 32),
            fileMD5: new Token.Uint8ArrayType(16).get(buf, off + 36)
        };
    }
};
exports.Header = {
    len: 24,
    get: (buf, off) => {
        return {
            compressionLevel: Token.UINT16_LE.get(buf, off),
            formatFlags: Token.UINT16_LE.get(buf, off + 2),
            blocksPerFrame: Token.UINT32_LE.get(buf, off + 4),
            finalFrameBlocks: Token.UINT32_LE.get(buf, off + 8),
            totalFrames: Token.UINT32_LE.get(buf, off + 12),
            bitsPerSample: Token.UINT16_LE.get(buf, off + 16),
            channel: Token.UINT16_LE.get(buf, off + 18),
            sampleRate: Token.UINT32_LE.get(buf, off + 20)
        };
    }
};
exports.TagFooter = {
    len: 32,
    get: (buf, off) => {
        return {
            ID: new Token.StringType(8, 'ascii').get(buf, off),
            version: Token.UINT32_LE.get(buf, off + 8),
            size: Token.UINT32_LE.get(buf, off + 12),
            fields: Token.UINT32_LE.get(buf, off + 16),
            flags: parseTagFlags(Token.UINT32_LE.get(buf, off + 20))
        };
    }
};
exports.TagItemHeader = {
    len: 8,
    get: (buf, off) => {
        return {
            size: Token.UINT32_LE.get(buf, off),
            flags: parseTagFlags(Token.UINT32_LE.get(buf, off + 4))
        };
    }
};
const TagField = footer => {
    return new Token.Uint8ArrayType(footer.size - exports.TagFooter.len);
};
exports.TagField = TagField;
function parseTagFlags(flags) {
    return {
        containsHeader: isBitSet(flags, 31),
        containsFooter: isBitSet(flags, 30),
        isHeader: isBitSet(flags, 31),
        readOnly: isBitSet(flags, 0),
        dataType: (flags & 6) >> 1
    };
}
exports.parseTagFlags = parseTagFlags;
function isBitSet(num, bit) {
    return (num & 1 << bit) !== 0;
}
exports.isBitSet = isBitSet;
